import { ExcuseDefinition, MNSproCloudApi } from '../..';
import { AbsenceReasonResponse, ExcuseDefinitionResponse } from '../../api/v2';

export class ExcuseDefinitionService {
  static async getAllExcuseDefinitions(
    authToken: string,
    organizationId: string,
  ): Promise<ExcuseDefinition[]> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);

    const result = await api.getAllAbsenceExcuseDefinitions(organizationId, false);

    return result.data as ExcuseDefinition[];
  }

  static async createExcuseDefinitions(
    authToken: string,
    organizationId: string,
    excuseDefinition: ExcuseDefinition,
  ): Promise<ExcuseDefinition> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);

    const result = await api.createAbsenceExcuseDefinition(organizationId ?? '', excuseDefinition);
    return result.data as ExcuseDefinition;
  }

  static async updateAExcuseDefinition(
    authToken: string,
    organizationId: string,
    excuseDefinition: ExcuseDefinitionResponse,
  ): Promise<ExcuseDefinition> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);

    const result = await api.updateAbsencesExcuseDefinition(organizationId ?? '', excuseDefinition);
    return result.data as ExcuseDefinition;
  }

  static async deleteExcuseDefinition(
    authToken: string,
    organizationId: string,
    excuseDefinitionId: string,
  ): Promise<void> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);

    await api.deleteAbsenceExcuseDefinition(excuseDefinitionId, organizationId);
  }

  /**
   * Get all reasons which are using the given excuse definition.
   */
  static async getAbsenceReasonsOfDefinition(
    authToken: string,
    organizationId: string,
    excuseDefinitionId: string,
  ): Promise<AbsenceReasonResponse[]> {
    const config = MNSproCloudApi.V2.createConfiguration(authToken);
    const api = MNSproCloudApi.V2.ClassRegisterApiFactory(config);

    const response = await api.getAbsenceReasonsOfDefinition(organizationId, excuseDefinitionId);

    return response.data;
  }
}
